import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';
import { FilesModule } from '@core/components/files/files.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillShortTextV1FieldComponent } from './fill-short-text-v1/fill-short-text-v1.component';
import { ViewShortTextV1FieldComponent } from './view-short-text-v1/view-short-text-v1.component';
import { SettingsShortTextV1FieldComponent } from './settings-short-text-v1/settings-short-text-v1.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillShortTextV1FieldComponent,
        ViewShortTextV1FieldComponent,
        SettingsShortTextV1FieldComponent
    ],
    exports: [
        FillShortTextV1FieldComponent,
        ViewShortTextV1FieldComponent,
        SettingsShortTextV1FieldComponent
    ],

})
export class CoreCustomFormsFieldShortTextV1FieldsModule { }
